import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {ColorTheme, IconContainerProps} from "../types";

export const PlayIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
  const isLight = colortheme === ColorTheme.light;

  const CrossBrandSVG = (
    <svg fill="none" viewBox="0 0 13 14" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 1.67422C0 .917542.807869.435006 1.4741.793746l9.8907 5.325784c.7012.37757.7012 1.38337 0 1.76094L1.4741 13.2063C.807868 13.565 0 13.0825 0 12.3258V1.67422z"
        fill="#666"
      />
    </svg>
  );

  const GapSVG = (
    <svg viewBox="0 0 15.03 18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 18V0l15.03 9ZM1.43 2.52v12.95L12.24 9Z"
        fill={isLight ? theme.color.wh : theme.color.b1}
      />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: CrossBrandSVG,
    [Brands.BananaRepublic]: CrossBrandSVG,
    [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: CrossBrandSVG,
    crossBrand: CrossBrandSVG,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
